import React, { useState, useRef, useEffect } from 'react';
import { Layout as AntLayout, Menu, Dropdown, Button, Drawer, message } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { logout, setUserInfo } from '@/store/slices/userSlice';
import styles from './Layout.module.scss';
import enIcon from '@/assets/images/en.png';
import zhIcon from '@/assets/images/zh.png';
import esIcon from '@/assets/images/es.png';
import jpIcon from '@/assets/images/日语.png';
import frIcon from '@/assets/images/法语.png';
import deIcon from '@/assets/images/德语.png';
import itIcon from '@/assets/images/意大利语.png';
import ruIcon from '@/assets/images/俄语.png';
import userAvatar from '@/assets/images/c642aea46612126d21e6c7243617286-01@2x.png';
import {

    DownOutlined,
    MenuOutlined
} from '@ant-design/icons';


import type { GetProp, MenuProps } from 'antd';
import SearchBar from '@/components/SearchBar/SearchBar';
import SideBar from '@/components/SideBar/SideBar';
import BasicFooter from '@/components/Footer';
import Membership from '@/components/Membership';



const { Header, Content } = AntLayout;
const { SubMenu } = Menu;

const Layout: React.FC = () => {
    //是否是会员
    const [isMember, setIsMember] = useState<boolean>(false);
    // 添加会员弹窗状态控制
    const [membershipModalOpen, setMembershipModalOpen] = useState<boolean>(false);
    // 支付成功弹窗
    const [showPaySuccess, setShowPaySuccess] = useState(false);

    //是否是手机端
    const isMobile = useAppSelector((state) => state.searchBar.isMobile);

    const userInfo = useAppSelector((state) => state.user.userInfo);

    const dispatch = useAppDispatch();

    //国际化语言切换
    const { t, i18n } = useTranslation();

    //聊天内容dom对象
    const headerRef = useRef<HTMLHeadElement>(null);

    // 获取当前路径信息
    const location = useLocation();

    //路由跳转对象
    const navigate = useNavigate();

    // 控制登录卡片是否显示
    const [showLoginCard, setShowLoginCard] = useState<boolean>(false);

    // 根据当前路径获取选中的菜单项
    const getSelectedKeys = () => {
        const path = location.pathname;

        if (path === '/' || path === '/home') {
            return ['yourtownloop'];
        } else if (path === '/carpoolService') {
            return ['Ride'];
        } else if (path.includes('/yourtownloop/yourProducts')) {
            return ['MediaShowcase'];
        } else if (path.includes('/yourtownloop')) {
            return ['yourtownloop'];
        } else if (path === '/liveNow') {
            return ['LiveNow']
        } else if (path === '/StorePublishProductShowcase') {
            return ['MediaShowcase'];
        }

        return [];
    };

    // 根据当前路径获取需要展开的子菜单
    const getOpenKeys = () => {
        const path = location.pathname;

        // 只有访问子菜单项时才展开父菜单，访问父菜单本身不展开
        // if (path === '/carpoolService') {
        //     return ['ServiceBooking'];
        // }

        return [];
    };

    // 控制子菜单展开状态
    const [openKeys, setOpenKeys] = useState<string[]>(getOpenKeys());

    // 监听路径变化，更新菜单选中状态
    useEffect(() => {
        setOpenKeys(getOpenKeys());
    }, [location.pathname]);

    type MenuItem = GetProp<MenuProps, 'items'>[number];

    // 检查用户是否已经是商家
    const isMerchant = () => {
        if (!userInfo) return false;
        return userInfo.merchant_id !== null && userInfo.merchant_id !== undefined;
    };

    //pc端主菜单数据
    // const items: MenuItem[] = [

    //     {
    //         key: 'yourtownloop',
    //         label: 'Latest',
    //         onClick: () => navigate('/'),
    //     },
    //     // 服务预定
    //     {
    //         key: 'ServiceBooking',
    //         label: 'Service Booking',
    //         onClick: () => message.info('Coming soon'),
    //     },

    //     // 直播菜单
    //     {
    //         key: 'LiveNow',
    //         label: 'Live Now',
    //         onClick: () => message.info('Coming soon'),
    //     },


    //     // 会员服务
    //     {
    //         key: 'Membership',
    //         label: 'Membership',
    //         // onClick: () => {
    //         //     console.log('Membership clicked, navigating to /membershipService');
    //         //     navigate('/membershipService');
    //         // },
    //         children: [
    //             {
    //                 key: 'Ride',
    //                 label: 'Ride Board',
    //                 // onClick: () => navigate('/carpoolService'),
    //             },
    //             {
    //                 key: 'Emergency',
    //                 label: 'Equipment Rental',
    //                 // onClick: () => message.info('Coming soon'),
    //             },
    //         ],
    //     },

    //     // 图文混排
    //     ...(
    //         isMerchant()
    //         ? [{
    //             key: 'MediaShowcase',
    //             label: 'Media Showcase',
    //             onClick: () => navigate('/yourtownloop/yourProducts'),
    //         },]
    //         : []
    //     ),







    //     // 紧急服务
    //     // {
    //     //     key: 'emergencyService',
    //     //     label: 'Emergency Service',
    //     //     onClick: () => navigate('/emergencyService'),
    //     // },

    //     // {
    //     //     key: 'chatList',
    //     //     label: 'Message',
    //     //     onClick: () => navigate('/chatList'),
    //     // },
    //     // 商家显示“Visit My Store”，非商家显示“Store Entry”

    //     // {
    //     //     key: '6',
    //     //     label: '多菜单',
    //     //     onClick: () => navigate('/aboutUs'),
    //     //     children: [
    //     //         {
    //     //             type: 'group',
    //     //             label: 'Item 1',
    //     //             children: [
    //     //                 { label: 'Option 1', key: 'setting:1' },
    //     //                 { label: 'Option 2', key: 'setting:2' },
    //     //             ],
    //     //         },
    //     //         {
    //     //             type: 'group',
    //     //             label: 'Item 2',
    //     //             children: [
    //     //                 { label: 'Option 3', key: 'setting:3' },
    //     //                 { label: 'Option 4', key: 'setting:4' },
    //     //             ],
    //     //         },
    //     //     ],
    //     // },
    // ];



    const handleClick: MenuProps['onClick'] = ({ key }) => {
        console.log('Menu clicked:', key);

        // 处理子菜单点击
        if (key === 'Ride') {
            //如果乘客还没有注册会员
            if (!isMember) {
                setMembershipModalOpen(true);
                return;
            }
            navigate('/carpoolService');
        } else if (key === 'Emergency') {
            message.info(t('common.comingSoon'));
        }
        // 其他菜单项的onClick已经在组件中直接定义
    };

    //移动端专用主菜单数据
    const mobileItems: MenuItem[] = [
        {
            key: 'yourtownloop',
            label: 'townloop',
            onClick: () => navigate('/yourtownloop'),
        },
        {
            key: 'orders',
            label: 'Order',
            onClick: () => navigate('/yourtownloop/orders'),
        },
        {
            key: 'favorites',
            label: 'Favorites',
            onClick: () => navigate('/yourtownloop/favorites'),
        },
        {
            key: 'chatList',
            label: 'Message',
            onClick: () => navigate('/chatList'),
        },
        {
            key: 'cart',
            label: 'Cart',
            onClick: () => navigate('/yourtownloop/cart'),
        },
        // 商家显示Visit My Store，非商家显示Store Entry
        ...(
            isMerchant()
                ? [{
                    key: 'yourStore',
                    label: 'Visit My Store',
                    onClick: () => navigate('/yourtownloop/yourStore'),
                }]
                : [{
                    key: 'StoreEntry',
                    label: 'Store Entry',
                    onClick: () => navigate('/StoreEntry'),
                }]
        ),
        {
            key: 'login',
            label: 'Login',
            onClick: () => navigate('/login'),
        },

    ];

    //i18n下拉菜单数据
    const menu = [
        {
            key: '0',
            label: 'English',
            value: 'en',
            icon: <img src={enIcon} alt="en" className={styles['icon']} />,
        },
        {
            key: '1',
            label: '中文',
            value: 'zh',
            icon: <img src={zhIcon} alt="zh" className={styles['icon']} />,
        },
        {
            key: '2',
            label: 'Español',
            value: 'es',
            icon: <img src={esIcon} alt="es" className={styles['icon']} />,
        },
        {
            key: '3',
            label: '日本語',
            value: 'jp',
            icon: <img src={jpIcon} alt="jp" className={styles['icon']} />
        },
        {
            key: '4',
            label: 'Français',
            value: 'fr',
            icon: <img src={frIcon} alt="fr" className={styles['icon']} />,
        },
        {
            key: '5',
            label: 'Deutsch',
            value: 'de',
            icon: <img src={deIcon} alt="de" className={styles['icon']} />,
        },
        {
            key: '6',
            label: 'Русский',
            value: 'ru',
            icon: <img src={ruIcon} alt="ru" className={styles['icon']} />,
        },
        {
            key: '7',
            label: 'Italiano',
            value: 'it',
            icon: <img src={itIcon} alt="it" className={styles['icon']} />,
        },
    ];

    //i18n下拉菜单选中值
    const [selectedValue, setSelectedValue] = useState<string>('0');

    useEffect(() => {
        const obj = menu.find(item => item.value === i18n.language)
        setSelectedValue(obj?.key || '0');
    }, [i18n.language]);
    //i18n下拉菜单点击事件
    const handleMenuClick: MenuProps['onClick'] = (e) => {
        const selectedItem = menu.find(item => item.key === e.key);
        if (selectedItem) {
            i18n.changeLanguage(selectedItem.value);
            localStorage.setItem('i18nextLng', selectedItem.value);
            setSelectedValue(e.key);
            setTimeout(() => window.location.reload(), 200);
        }
    };
    // 处理会员购买弹窗的回调函数
    const handleMembershipCancel = () => {
        setMembershipModalOpen(false);
    };
    const loginout = () => {
        const currentPath = window.location.pathname + window.location.search;
        localStorage.setItem('locationHref', String(currentPath));
        dispatch(logout());
        navigate('/login');
    };
    //支付会员确认
    const handleMembershipConfirm = (values: any) => {
        console.log('Membership purchase confirmed:', values);

        // 检查是否是支付成功
        if (values.paymentSuccess) {
            message.success('Membership purchased successfully! You can now submit emergency service requests.');
            setMembershipModalOpen(false);
            setIsMember(true);
            setShowPaySuccess(true);



            // // 支付成功后，更新 localStorage 中的 userinfo
            const userInfoStr = localStorage.getItem('userInfo');
            let userInfo = userInfoStr ? JSON.parse(userInfoStr) : {};
            //把购买的会员标识手动处理
            userInfo.carpool_service_member = true;

            dispatch(setUserInfo(userInfo));


        } else {
            setMembershipModalOpen(false);
            // // 如果没有支付成功信息，按原来的逻辑处理

        }
    };
    // 是否是会员
    useEffect(() => {
        setIsMember(!!userInfo?.carpool_service_member);
    }, [userInfo]);
    const storeEntry = () => {
        if (userInfo) {
            if (!isMember) {
                console.log('isMember: ' + isMember);
                setMembershipModalOpen(true);
            } else {
                if (isMerchant()) {
                    // navigate('/yourtownloop/yourStore');
                    navigate('/yourtownloop?flag=2');
                } else {
                    navigate('/StoreEntry');
                }
            }

        } else {
            navigate('/login');
        }

    };

    const [contentMarginTop, setContentMarginTop] = useState<number>(0);
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        const updateMargin = () => {

            const height = headerRef?.current?.clientHeight || 0;
            setContentMarginTop(height + 40);
        };
        updateMargin();
        // 监听窗口大小变化，header高度可能会变
        window.addEventListener('resize', updateMargin);
        return () => window.removeEventListener('resize', updateMargin);
    }, [location.pathname, selectedValue]); // 路由和语言切换都重新计算

    return (
        <AntLayout
            className={styles.layout}
        >
            <Membership
                open={membershipModalOpen}
                onCancel={handleMembershipCancel}
                onConfirm={handleMembershipConfirm}
                membershipType={1}
            />
            <SideBar />
            <Header className={styles.header} ref={headerRef}>
                <div className={styles['menu-box']}>
                    <div className={styles['header-left']}>
                        <div className={styles.logo} onClick={() => navigate('/')}></div>
                        <div style={{ flex: 1 }}>
                            {isMobile ? (
                                <>

                                    <Drawer
                                        placement="left"
                                        open={drawerOpen}
                                        onClose={() => setDrawerOpen(false)}
                                    >
                                        <Menu
                                            theme="light"
                                            mode="inline"
                                            selectedKeys={[location.pathname.split('/').pop() || 'yourtownloop']}
                                            items={mobileItems}
                                            onClick={() => setDrawerOpen(false)}
                                        />
                                    </Drawer>
                                </>
                            ) : (
                                <Menu
                                    theme="light"
                                    mode="horizontal"
                                    selectedKeys={getSelectedKeys()}
                                    openKeys={openKeys}
                                    onOpenChange={setOpenKeys}
                                    onClick={handleClick}
                                    items={[
                                        {
                                        key: "yourtownloop",
                                        label: t('common.Latest'),
                                        onClick: () => navigate('/') // 保留原点击跳转逻辑
                                        },
                                        {
                                        key: "MediaShowcase",
                                        label: t('common.MediaShowcase'),
                                        onClick: () => navigate('/StorePublishProductShowcase') // 保留原点击跳转逻辑
                                        }
                                    ]}
                                />
                                // <Menu
                                //     theme="light"
                                //     mode="horizontal"
                                //     selectedKeys={getSelectedKeys()}
                                //     openKeys={openKeys}
                                //     onOpenChange={setOpenKeys}
                                //     onClick={handleClick}
                                // >
                                //     <Menu.Item key="yourtownloop" onClick={() => navigate('/')}>
                                //         {t('common.Latest')}
                                //     </Menu.Item>
                                //     <Menu.Item key="MediaShowcase" onClick={() => navigate('/StorePublishProductShowcase')}>
                                //         {t('common.MediaShowcase')}
                                //     </Menu.Item>

                                //     {/* <SubMenu key="ServiceBooking" title={t("common.ServiceBooking")} >
                                //         <Menu.Item key="Ride">{t("common.RideBoard")}</Menu.Item>
                                //         <Menu.Item key="Emergency">{t('EquipmentRental')}</Menu.Item>
                                //     </SubMenu> */}

                                //     {/* <Menu.Item key="LiveNow" onClick={() => navigate('/liveNow')}>
                                //         {t('common.LiveNow')}
                                //     </Menu.Item> */}



                                //     {//isMerchant() && (
                                    
                                //         //)
                                //     }
                                // </Menu>
                            )}
                        </div>
                    </div>

                    <div className={styles['header-right']}>
                        <div className={styles['header-i18n']}>
                            {
                                !isMobile &&
                                <div className={styles['header-i18n-icon']}></div>
                            }


                            <div className={styles['header-i18n-select']}>
                                <Dropdown
                                    menu={{
                                        items: menu,
                                        onClick: handleMenuClick,
                                    }}
                                    className={styles['header-i18n-Dropdown']}
                                >
                                    <Button>
                                        {menu[Number(selectedValue)]?.icon}

                                        <span className={styles['dropdown-text']}>{menu[Number(selectedValue)]?.label}</span>
                                        <DownOutlined />
                                    </Button>
                                </Dropdown>
                            </div>
                        </div>

                        {/* 移动端菜单显示 */}

                        {
                            isMobile &&
                            <Button
                                icon={<MenuOutlined />}
                                onClick={() => setDrawerOpen(true)}
                                className={styles['mobile-menu-btn']}
                                type="text"
                            />
                        }
                        {
                            (!isMobile) &&
                            <div className={styles['login-info']}>
                                <div
                                    className={styles['login-info-text']}
                                    onClick={() => storeEntry()}
                                >{t('common.StoreEntry')}</div>
                            </div>
                        }

                        {
                            !isMobile &&
                            <div
                                className={styles['login-info']}
                                onMouseEnter={() => userInfo && setShowLoginCard(true)}
                                onMouseLeave={() => userInfo && setShowLoginCard(false)}
                            >

                                {
                                    !userInfo ?
                                        <div
                                            className={styles['login-info-text']}
                                            onClick={() => navigate('/login')}
                                        >{t('login.title')}</div>
                                        :
                                        <div
                                            className={styles['login-info-text2']}
                                            onClick={() => navigate('/yourtownloop')}
                                            title={userInfo?.username || 'tl147258666tl147258666'}
                                        >{userInfo?.username || 'tl147258666tl147258666'}</div>
                                }

                                {/* 登录悬浮卡片 */}
                                {(!!userInfo && showLoginCard) && (
                                    <div className={styles['login-card']}>
                                        <div className={styles['login-card-header']}>
                                            <img
                                                className={styles['user-avatar']}
                                                src={userAvatar}
                                            />
                                            <div className={styles['user-info']}>
                                                <div
                                                    className={styles['user-id']}
                                                >
                                                    {userInfo?.username || 'tl147258666tl147258666'}
                                                </div>
                                                <div className={styles['manage-accounts']}>
                                                    <span onClick={() => navigate('/yourtownloop')}>{t('common.ManageAccounts')}</span>
                                                    <span className={styles['divider']}>|</span>
                                                    <span
                                                        className={styles['exit']}
                                                        onClick={() => {
                                                            loginout()                                                                                                                   
                                                        }}
                                                    >{t('login.exit')}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={styles['login-card-content']}>
                                            <div className={styles['exclusive-benefits']} onClick={() => navigate('/membershipService')}>
                                                {t("common.Membership")}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        }


                        {
                            !isMobile &&
                            <div
                                className={styles['shopping-cart']}
                                onClick={() => navigate('/yourtownloop/cart')}
                            >
                                <div
                                    className={styles['shopping-cart-icon']}
                                ></div>
                            </div>
                        }

                        {
                            !isMobile &&
                            <div className={styles['my-message']}>
                                <div className={styles['my-message-icon']}></div>
                            </div>
                        }

                    </div>
                </div>
                {
                    location.pathname == '/' && <SearchBar></SearchBar>
                }

                {
                    location.pathname == '/liveNow' && <SearchBar></SearchBar>
                }

            </Header>
            <Content
                className={`${styles.content} ${location.pathname == '/chatList' && !isMobile ? styles['layout-chat-bg'] : ''}`}
                style={{ marginTop: contentMarginTop }}>

                <div className={styles['site-layout-content']}>
                    {/* Outlet渲染子路由 */}
                    <Outlet />
                </div>
            </Content>
            {
                location.pathname !== '/chatList' &&
                <BasicFooter>

                </BasicFooter>
            }

        </AntLayout>
    );
};

export default Layout; 